import React, { createContext, useContext, useReducer } from 'react';
import { DeclarationResponse } from '../Interfaces/Declaration.Interface';

type FormAction = {
  type: string;
  payload: any;
};

const declarationInitialState: DeclarationResponse = {
  step: 0,
  loading: false,
  elementForm: undefined,
  currentForm: 1,
  headerTitle: '',
  fixOptionDescriptionAccidemt: '',
  claimDate: undefined,
  claimTime: '',
  hasAPoliceReport: false,
  claimCauseId: '',
  description: '',
  vehicleDamageComponents: '',
  additionalNotes: '',
  signages: [],
  shortId: null,
  vehiclePatente: {
    deviceId: '',
    brand: '',
    model: '',
    year: '',
    customerIdentityNumber: '',
    customerName: '',
    contractSupervisorEmail: '',
    chasisNumber: "",
    engineNumber: ""
  },
  // Lo que se va a enviar
  address: {
    streetAndNumber: '',
    city: '',
    communeId: '',
  },
  declarant: {
    identifierType: '',
    identifierTypeClient: '',
    customerName: '',
    customerIdentityNumber: '',
    declarantIdentityNumber: '',
    declarantFullName: '',
    phoneNumber: { phone_code: '+56', stringValue: '' },
    emails: [],
  },
  driver: {
    identifierType: 'rut',
    identityNumber: '',
    fullName: '',
    phoneNumber: { phone_code: '+56', stringValue: '' },
    emails: [],
    isConsideredGuilty: false,
    licenseTypeId: '',
    licenseClassId: '',
    hasValidLicense: false,
    licenseValidityStartDate: '',
    licenseValidityEndDate: '',
  },
  policeReport: {
    policeStationReference: '',
    declarationDate: null,
    policeReportNumber: '',
    hasACourtDate: false,
    reportDate: '',
    alcoholTestConducted: false,
    InjuriesOcurred: false,
    judicialCourt: {
      name: '',
      citation_date: null,
    },
    licenseRetention: false,
  },
  thirdPartyInvolved: {
    propertyInvolved: false,
    peopleInjured: false,
    thirdPartyInformationAvailable: false,
  },
  reCaptcha: '',
  state_form: {
    regionId: '',
    nameOptionDescriptionAccidemt: '',
    nameClaimCauseId: '',
  },
  state_document: [
    {
      documentType: 'LIC',
      filename: null,
      url: '',
      obligatorio: true,
      nombreTitulo: 'Licencia de conducir/permiso provisorio',
      isActive: true,
    },
    {
      documentType: 'DOCID',
      filename: null,
      url: '',
      obligatorio: true,
      nombreTitulo: 'Documento de identificación RUT/Pasaporte',
      isActive: true,
    },
    {
      documentType: 'ALC',
      filename: null,
      url: '',
      obligatorio: true,
      nombreTitulo: 'Alcoholemia',
      isActive: false,
    },
    {
      documentType: 'FDF',
      filename: null,
      url: '',
      obligatorio: true,
      nombreTitulo: 'Formulario de declaración firmada',
      isActive: true,
    },
    {
      documentType: 'CRQ',
      filename: null,
      url: '',
      obligatorio: true,
      nombreTitulo: 'Croquis',
      isActive: false,
    },
    {
      documentType: 'CROB',
      filename: null,
      url: '',
      obligatorio: true,
      nombreTitulo: 'Cuestionario de robo',
      isActive: false,
    },
    {
      documentType: 'PTP',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Parte policial / Denuncia',
      isActive: false,
    },
    {
      documentType: 'DOCA1',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Documento adicional 1',
      isActive: false,
    },
    {
      documentType: 'DOCA2',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Documento adicional 2',
      isActive: false,
    },
    {
      documentType: 'DOCA3',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Documento adicional 3',
      isActive: false,
    },
    {
      documentType: 'DOCA4',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Documento adicional 4',
      isActive: false,
    },
    {
      documentType: 'DOCA5',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Documento adicional 5',
      isActive: false,
    },
    {
      documentType: 'FDVP1',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo propios 1',
      isActive: false,
    },
    {
      documentType: 'FDVP2',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo propios 2',
      isActive: false,
    },
    {
      documentType: 'FDVP3',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo propios 3',
      isActive: false,
    },
    {
      documentType: 'FDVP4',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo propios 4',
      isActive: false,
    },
    {
      documentType: 'FDVP5',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo propios 5',
      isActive: false,
    },
    {
      documentType: 'FDVP6',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo propios 6',
      isActive: false,
    },
    {
      documentType: 'FDV31',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo o bien del tercero 1',
      isActive: false,
    },
    {
      documentType: 'FDV32',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo o bien del tercero 2',
      isActive: false,
    },
    {
      documentType: 'FDV33',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo o bien del tercero 3',
      isActive: false,
    },
    {
      documentType: 'FDV34',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo o bien del tercero 4',
      isActive: false,
    },
    {
      documentType: 'FDV35',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo o bien del tercero 5',
      isActive: false,
    },
    {
      documentType: 'FDV36',
      filename: null,
      url: '',
      obligatorio: false,
      nombreTitulo: 'Foto daños del vehículo o bien del tercero 6',
      isActive: false,
    },
  ],
};

const FormReducer = (state: DeclarationResponse, action: FormAction): DeclarationResponse => {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'UPDATE_ADDRESS':
      return {
        ...state,
        address: action.payload,
      };

    case 'UPDATE_STEP':
      return {
        ...state,
        step: action.payload,
      };

    case 'UPDATE_CURRENT_FORM':
      return {
        ...state,
        currentForm: action.payload,
      };

    case 'SET_HEADER_TITLE':
      return {
        ...state,
        headerTitle: action.payload,
      };

    case 'UPDATE_VEHICLE_PATENT':
      console.log('action.payload', action.payload);
      return {
        ...state,
        vehiclePatente: action.payload,
      };

    case 'UPDATE_VEHICLE_INFO_RUT':
      return {
        ...state,
        // vehiclePatente: {
        //     ...state.vehiclePatente,
        //     customerIdentityNumber: action.payload.customerIdentityNumber

        // }
      };

    case 'UPDATE_DECLARANT':
      return {
        ...state,
        declarant: action.payload,
      };

    case 'UPDATE_DRIVER':
      return {
        ...state,
        driver: action.payload,
      };

    case 'UPDATE_DRIVER_PERSONAL_INFO':
      return {
        ...state,
        driver: {
          ...state.driver,
          fullName: action.payload.fullName,
          phoneNumber: action.payload.phoneNumber,
          emails: action.payload.emails,
          identifierType: action.payload.identifierType,
          identityNumber: action.payload.identityNumber,
        },
      };

    case 'UPDATE_POLICE_REPORT':
      return {
        ...state,
        claimDate: action.payload.claimDate,
        claimTime: action.payload.claimTime,
        hasAPoliceReport: action.payload.hasAPoliceReport,
        policeReport: action.payload.policeReport,
        address: action.payload.address,
      };

    case 'UPDATE_DESCRIPTIONS_ACCIDENT':
      return {
        ...state,
        fixOptionDescriptionAccidemt: action.payload.fixOptionDescriptionAccidemt,
        claimCauseId: action.payload.claimCauseId,
        description: action.payload.description,
        vehicleDamageComponents: action.payload.vehicleDamageComponents,
        additionalNotes: action.payload.additionalNotes,
        signages: action.payload.signages,
      };

    case 'UPDATE_THIRD_PARTY_INVOLVED':
      return {
        ...state,
        thirdPartyInvolved: {
          propertyInvolved: action.payload?.propertyInvolved,
          peopleInjured: action.payload?.peopleInjured,
          thirdPartyInformationAvailable: action.payload?.thirdPartyInformationAvailable,
        },
      };

    case 'UPDATE_THIRD_PARTY_INVOLVED_INFORMATION':
      return {
        ...state,
        thirdPartyInvolved: {
          ...state.thirdPartyInvolved,
          thirdPartyInvolvedInformation: action.payload,
        },
      };

    case 'UPDATE_RECAPTCHA':
      return {
        ...state,
        reCaptcha: action.payload,
      };

    case 'UPDATE_STATE_FORM':
      return {
        ...state,
        state_form: action.payload,
      };

    case 'UPDATE_STATE_DOCUMENT':
      return {
        ...state,
        state_document: action.payload,
      };
    case 'UPDATE_CURRENT_FORM_ELEMENT':
      return {
        ...state,
        elementForm: action.payload,
      };
    case 'UPDATE_SHORT_ID':
      return {
        ...state,
        shortId: action.payload,
      };
    case 'CLEAN_DECLARATION_FORM_STATE':
      return {
        ...declarationInitialState,
        state_document: declarationInitialState.state_document?.map((doc) => ({ ...doc, filename: null })),
      };
    default:
      return state;
  }
};

const FormContext = createContext<{
  state: DeclarationResponse;
  dispatch: React.Dispatch<FormAction>;
}>({
  state: declarationInitialState,
  dispatch: () => null,
});

const FormDeclarationProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(FormReducer, declarationInitialState);
  return <FormContext.Provider value={{ state, dispatch }}>{children}</FormContext.Provider>;
};

const useFormContext = () => useContext(FormContext);

export { FormDeclarationProvider, useFormContext };
